
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface SaveButtonProps {
  quotation: any;
}

export function SaveButton({ quotation }: SaveButtonProps) {
  const { toast } = useToast();

  const saveQuotation = () => {
    toast({
      title: "Salvando orçamento...",
      description: "O orçamento está sendo preparado para download.",
    });
    
    // Here you would implement the logic to generate and download the PDF
    // For now, just showing a toast for demonstration
    setTimeout(() => {
      toast({
        title: "Orçamento salvo!",
        description: `O orçamento ${quotation.code} foi salvo com sucesso.`,
      });
    }, 1500);
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={saveQuotation}
      className="hover:bg-[#0073B7] hover:text-white"
      title="Salvar orçamento"
    >
      <Save className="h-4 w-4" />
    </Button>
  );
}
